import React from "react";
import {withNamespaces} from "react-i18next";
import DateRangeFilter from "../../../../components/FilterField/DateRangeFilter";
import Moment from "react-moment";
import {hilightTableAdvancedService} from "../../../../services/hilight-table-advanced.service";
import HilightTableAdvanced from "../../../../components/HilightTableAdvanced";
import {Button} from "react-bootstrap";
import JSONPretty from "react-json-pretty";


const NetworkDeviceLogsTable = ({t, networkDeviceId}) => {

    const fetchIdRef                = React.useRef(0);
    const [data, setData]           = React.useState([]);
    const [loading, setLoading]     = React.useState(false);
    const [pageCount, setPageCount] = React.useState(0);
    const [itemCount, setItemCount] = React.useState(0);

    const [requestUrlParams, setRequestUrlParams] = React.useState({});

    const apiUrl = `/api/logs/GetEventLog/${networkDeviceId}`;

    const columns = [
        {
            Header: '',
            id: 'expander',
            Cell: ({ row }) => (
                <span {...row.getToggleRowExpandedProps()}>
                    {row.isExpanded ? (
                        <Button size={"sm"} variant={"outline-info"}>
                            <i className="fas fa-arrow-right"/>
                        </Button>
                    ) : (
                        <Button size={"sm"} variant={"outline-info"}>
                            <i className="fas fa-arrow-down"/>
                        </Button>
                    )}
                </span>
            )
        },
        {
            Header: 'hash',
            accessor: 'id',
            disableFilter: true
        },
        {
            Header: 'insert-data',
            accessor: 'insertDate',
            Filter: DateRangeFilter,
            Cell: (props) => {
                const data = props.row.original;
                return <Moment format="YYYY-MM-DD HH:mm:ss">{data.insertDate}</Moment>
            }
        },
        {
            Header: 'className',
            accessor: 'className'
        },
        {
            Header: 'logType',
            accessor: 'logType'
        },
        {
            Header: 'message',
            accessor: 'message'
        }
    ];

    const fetchData = React.useCallback(({ urlParams, pageSize }) => {
        const fetchId = ++fetchIdRef.current;
        setLoading(true);
        if (fetchId === fetchIdRef.current) {
            hilightTableAdvancedService.getHilightTableRequest(apiUrl, urlParams)
                .then((resultData) => {
                    setRequestUrlParams(urlParams);
                    setData(resultData.logs);
                    setLoading(false);
                    setItemCount(resultData.allItemsCount);
                    setPageCount(Math.ceil(resultData.allItemsCount / pageSize));
                });
        }
    }, []);

    const renderRowSubComponent = (row) => {
        const json = JSON.parse(row.original.stackTrace);
        return (
            <JSONPretty id={"row.original.id"} data={json} />
        )
    };

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            <HilightTableAdvanced
                columns={columns}
                data={data}
                fetchData={fetchData}
                loading={loading}
                pageCount={pageCount}
                itemCount={itemCount}
                renderRowSubComponent={renderRowSubComponent}
                // filterModel={ActivityFilterModel}
            />
        </div>
    )
};
export default withNamespaces()(NetworkDeviceLogsTable);
